import type {
  CreateLedgerAccountMutationOptions,
  CreateLedgerAccountPayload,
} from './types';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysLedgerAccount } from '../queryKeys';

import { createLedgerAccount } from './createLedgerAccount';

/**
 * Custom hook for creating a new ledger account (Sachkonto).
 *
 * @param options - Additional options for the mutation.
 * @returns An object containing the mutation function and related properties.
 * @see https://app.dev.vestigas.com/redoc#tag/Ledger-Accounts/operation/create_ledger_account_ledger_accounts_post
 */
export const useMutationCreateLedgerAccount = (
  options?: CreateLedgerAccountMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateLedgerAccountPayload) =>
      createLedgerAccount(payload),
    ...options,
    onSuccess(data, variables, onMutateResult, context) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysLedgerAccount.getAll(),
      });

      return options?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
